var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBookmarked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_65_8204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 5.33301H21C21.7072 5.33301 22.3855 5.61396 22.8856 6.11406C23.3857 6.61415 23.6666 7.29243 23.6666 7.99967V26.6663L16 22.6663L8.33331 26.6663V7.99967C8.33331 7.29243 8.61426 6.61415 9.11436 6.11406C9.61446 5.61396 10.2927 5.33301 11 5.33301Z",
    fill: "#BA8D5B",
    stroke: "#BA8D5B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65_8204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBookmarked);
export default __webpack_public_path__ + "static/media/icon-bookmarked.400475dc90869e0f053ecc0b1058a475.svg";
export { ForwardRef as ReactComponent };